export default {
  items: function (profile) {

    var navigation = [];
    navigation.push({
      title: true,
      name: 'ALTAMENTE PORTAL MENU',
      class: '',
      wrapper: {
        element: '',
        attributes: {}
      }
    });

    //SHOPIFY USER
    if (profile.roles.includes("shopify"))
      navigation.push({
        name: 'Shopify',
        url: '/shopify',
        icon: 'icon-shopify',
        children: [
          // {
          //   name: 'Data snapshots',
          //   url: '/shopify/snapshots',
          //   icon: 'cui-arrow-bottom'
          // },
          {
            name: 'Bought Together',
            url: '/shopify/app/bought-together',
            icon: 'icon-arrows'
          }
        ]
      });

    //SHOPO USER
    if (profile.roles.includes("shopo"))
      navigation.push(
        {
          name: "ShopO",
          url: '/shopo',
          icon: 'icon-shopo',
          children: [
            {
              name: 'Predict Category',
              url: '/shopo/app/category-predict',
              icon: 'icon-flask'
            },
            {
              name: 'Similar Products',
              url: '/shopo/app/similar-products',
              icon: 'icon-flask'
            }
          ]
        });

    //DEMO    
    if (profile.roles.includes("parser"))
      navigation.push(
        {
          icon: 'icon-spider-web',
          name: 'Data scraper',
          url: '/shopo/app/category-predict',
        });


    //EVERY USER    
    navigation.push(
      {
        name: 'Settings',
        url: '/settings',
        icon: 'cui-settings'
      }
    );
    return navigation;
  }
}

